import { Box, BoxProps } from "@chakra-ui/react";
import { FiTruck } from "react-icons/fi";

export const TruckIcon = (props: BoxProps) => {
  return <Box as={FiTruck} height="20px" width="20px" {...props} />;
};
